import React from 'react'
import Text from '../Text'
import RadioButton from '../RadioButton/RadioButton'
import ProceedButton from './ProceedButton'

const Gender = ({
  value = 'M',
  onChange,
  onMoveNext,
  isLastStep,
  title,
  subtitle,
}) => {
  return (
    <div className="pt-12 px-4">
      <div className="space-y-3 pb-4">
        <Text
          tag="h2"
          variant="display"
          size="small"
          className="text-[#101828]"
        >
          {title || 'What is your gender?'}
        </Text>
        <Text tag="p" variant="body" size="medium" className="text-[#475467]">
          {subtitle || 'We ask your gender to ensure personalised support.'}
        </Text>
      </div>

      <div className="flex flex-col gap-4 mt-6">
        <RadioButton
          className="w-full rounded-[18px]"
          label="Male"
          isSelected={value === 'M'}
          onClick={() => onChange('gender', 'M')}
        />
        <RadioButton
          className="w-full rounded-[18px]"
          label="Female"
          isSelected={value === 'F'}
          onClick={() => onChange('gender', 'F')}
        />
      </div>
      <ProceedButton
        onMoveNext={onMoveNext}
        isLastStep={isLastStep}
        disabled={!value}
      />
    </div>
  )
}

export default Gender
